document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initFaq();
});

function initReveal() {
  var items = document.querySelectorAll('.fp-reveal, .fp-reveal-scale');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('fp-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fp-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach(function (el, i) {
    el.style.setProperty('--fp-i', i % 6);
    observer.observe(el);
  });
}

function initCountUp() {
  var counters = document.querySelectorAll('[data-fp-count]');
  if (!counters.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-fp-count')) || 0;
        var decimals = (el.getAttribute('data-fp-count').split('.')[1] || '').length;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.6 }
  );
  counters.forEach(function (el) { observer.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.fp-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.fp-faq-q');
    var answer = item.querySelector('.fp-faq-a');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('fp-open');
      items.forEach(function (other) {
        other.classList.remove('fp-open');
        other.querySelector('.fp-faq-a').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('fp-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
}
